import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr'; // For auth after login toast

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';

import { coreConfig } from 'app/app-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdsComponent } from './main/ganatak-dashboard/wajad/ads/ads.component';
import { AddAdsComponent } from './main/ganatak-dashboard/add-pages/add-ads/add-ads.component';
import { CounselorsComponent } from './main/ganatak-dashboard/wajad/counselors/counselors.component';
import { AddCounselorsComponent } from './main/ganatak-dashboard/add-pages/add-counselors/add-counselors.component';
import { StoresOffersComponent } from './main/ganatak-dashboard/wajad/stores-offers/stores-offers.component';
import { AddStoresOffersComponent } from './main/ganatak-dashboard/add-pages/add-stores-offers/add-stores-offers.component';
import { CancelationReasonComponent } from './main/ganatak-dashboard/wajad/cancelation-reason/cancelation-reason.component';
import { AddCancelationReasonComponent } from './main/ganatak-dashboard/add-pages/add-cancelation-reason/add-cancelation-reason.component';
import { CompaniesComponent } from './main/ganatak-dashboard/wajad/companies/companies.component';
import { AddCompaniesComponent } from './main/ganatak-dashboard/add-pages/add-companies/add-companies.component';
import { ConsultingComponent } from './main/ganatak-dashboard/wajad/consulting/consulting.component';
import { AddConsultingComponent } from './main/ganatak-dashboard/add-pages/add-consulting/add-consulting.component';
import { CategoriesComponent } from './main/ganatak-dashboard/wajad/categories/categories.component';
import { AddCategpriesComponent } from './main/ganatak-dashboard/add-pages/add-categpries/add-categpries.component';
import { ServicesComponent } from './main/ganatak-dashboard/wajad/services/services.component';
import { AddServicesComponent } from './main/ganatak-dashboard/add-pages/add-services/add-services.component';
import { TagsComponent } from './main/ganatak-dashboard/wajad/tags/tags.component';
import { AddTagsComponent } from './main/ganatak-dashboard/add-pages/add-tags/add-tags.component';
import { ArticlesComponent } from './main/ganatak-dashboard/wajad/articles/articles.component';
import { AddArticlesComponent } from './main/ganatak-dashboard/add-pages/add-articles/add-articles.component';
import { OffersComponent } from './main/ganatak-dashboard/wajad/offers/offers.component';
import { AddOffersComponent } from './main/ganatak-dashboard/add-pages/add-offers/add-offers.component';
import { AddLanguagePlantcardsComponent } from './main/ganatak-dashboard/add-pages/add-language-plantcards/add-language-plantcards.component';
import { AddUsersComponent } from './main/ganatak-dashboard/add-pages/add-users/add-users.component';
import { UsersComponent } from './main/ganatak-dashboard/wajad/users/users.component';
import { PlantCardsComponent } from './main/ganatak-dashboard/wajad/plant-cards/plant-cards.component';
import { SettingsDetailsComponent } from './main/ganatak-dashboard/wajad/settings-details/settings-details.component';
import { TermsConditionsComponent } from './main/ganatak-dashboard/wajad/terms-conditions/terms-conditions.component';
import { NotificationsComponent } from './main/ganatak-dashboard/wajad/notifications/notifications.component';
import { AboutComponent } from './main/ganatak-dashboard/wajad/about/about.component';
import { CurrenciesComponent } from './main/ganatak-dashboard/wajad/currencies/currencies.component';
import { CountriesComponent } from './main/ganatak-dashboard/wajad/countries/countries.component';
import { CitiesComponent } from './main/ganatak-dashboard/wajad/cities/cities.component';
import { LanguagePlansComponent } from './main/ganatak-dashboard/wajad/language-plans/language-plans.component';
import { OpenScreensComponent } from './main/ganatak-dashboard/wajad/open-screens/open-screens.component';
import { LanguageLightComponent } from './main/ganatak-dashboard/wajad/language-light/language-light.component';
import { GanatakCommunityComponent } from './main/ganatak-dashboard/wajad/ganatak-community/ganatak-community.component';
import { LanguageRootComponent } from './main/ganatak-dashboard/wajad/language-root/language-root.component';
import { LanguageSeedComponent } from './main/ganatak-dashboard/wajad/language-seed/language-seed.component';
import { LanguageSoilComponent } from './main/ganatak-dashboard/wajad/language-soil/language-soil.component';
import { LanguageStemComponent } from './main/ganatak-dashboard/wajad/language-stem/language-stem.component';
import { PaperformComponent } from './main/ganatak-dashboard/wajad/paperform/paperform.component';
import { SizesComponent } from './main/ganatak-dashboard/wajad/sizes/sizes.component';
import { LanguageCounselorspaymentComponent } from './main/ganatak-dashboard/wajad/language-counselorspayment/language-counselorspayment.component';
import { SlidersComponent } from './main/ganatak-dashboard/wajad/sliders/sliders.component';
import { AddCurrenciesComponent } from './main/ganatak-dashboard/add-pages/add-currencies/add-currencies.component';
import { AddCountriesComponent } from './main/ganatak-dashboard/add-pages/add-countries/add-countries.component';
import { AddCitiesComponent } from './main/ganatak-dashboard/add-pages/add-cities/add-cities.component';
import { AddLanguagePlansComponent } from './main/ganatak-dashboard/add-pages/add-language-plans/add-language-plans.component';
import { AddOpenScreensComponent } from './main/ganatak-dashboard/add-pages/add-open-screens/add-open-screens.component';
import { AddLanguageLightComponent } from './main/ganatak-dashboard/add-pages/add-language-light/add-language-light.component';
import { AddGanatakCommunityComponent } from './main/ganatak-dashboard/add-pages/add-ganatak-community/add-ganatak-community.component';
import { AddLanguageRootComponent } from './main/ganatak-dashboard/add-pages/add-language-root/add-language-root.component';
import { AddLanguageSeedComponent } from './main/ganatak-dashboard/add-pages/add-language-seed/add-language-seed.component';
import { AddLanguageSoilComponent } from './main/ganatak-dashboard/add-pages/add-language-soil/add-language-soil.component';
import { AddLanguageStemComponent } from './main/ganatak-dashboard/add-pages/add-language-stem/add-language-stem.component';
import { AddPaperformComponent } from './main/ganatak-dashboard/add-pages/add-paperform/add-paperform.component';
import { AddSizesComponent } from './main/ganatak-dashboard/add-pages/add-sizes/add-sizes.component';
import { AddLanguageCounselorspaymentComponent } from './main/ganatak-dashboard/add-pages/add-language-counselorspayment/add-language-counselorspayment.component';
import { AddSlidersComponent } from './main/ganatak-dashboard/add-pages/add-sliders/add-sliders.component';
import { VouchersComponent } from './main/ganatak-dashboard/wajad/vouchers/vouchers.component';
import { SignInComponent } from './main/sign-in/sign-in.component';
import { CommonModule } from '@angular/common';
import { AuthGuard, JwtInterceptor } from './auth/helpers';
import { EmployeesComponent } from './layout/components/miracle-components/employees/employees.component';
import { AnalyticsComponent } from './layout/components/miracle-components/analytics/analytics.component';
import { PrivacyPolicyComponent } from './layout/components/miracle-components/privacy-policy/privacy-policy.component';
import { AboutMiracleComponent } from './layout/components/miracle-components/about-miracle/about-miracle.component';
import { FrequentlyAskedComponent } from './layout/components/miracle-components/frequently-asked/frequently-asked.component';
import { AlertsComponent } from './layout/components/miracle-components/alerts/alerts.component';
import { ContractsComponent } from './layout/components/miracle-components/contracts/contracts.component';
import { InvestorsComponent } from './layout/components/miracle-components/investors/investors.component';
import { MiracleTermsComponent } from './layout/components/miracle-components/miracle-terms/miracle-terms.component';
import { PartnersListComponent } from './layout/components/miracle-components/partners-list/partners-list.component';
import { PartnersAddComponent } from './layout/components/miracle-components/partners-list/partners-add/partners-add.component';
import { EmployeeAddComponent } from './layout/components/miracle-components/employee-add/employee-add.component';
import { AddInvestorComponent } from './layout/components/miracle-components/investors/add-investor/add-investor.component';
import { EditInvestorComponent } from './layout/components/miracle-components/investors/edit-investor/edit-investor.component';
import { EditEmployeeComponent } from './layout/components/miracle-components/employees/edit-employee/edit-employee.component';
import { AddEmployeeComponent } from './layout/components/miracle-components/employees/add-employee/add-employee.component';
import { JobTitlesComponent } from './layout/components/miracle-components/employees/job-titles/job-titles.component';
import { AddJobTitlesComponent } from './layout/components/miracle-components/employees/job-titles/add-job-titles/add-job-titles.component';
import { EditJobTitlesComponent } from './layout/components/miracle-components/employees/job-titles/edit-job-titles/edit-job-titles.component';
import { InvestorDetailsComponent } from './layout/components/miracle-components/investors/investor-details/investor-details.component';
import { EmployeeDetailsComponent } from './layout/components/miracle-components/employees/employee-details/employee-details.component';
import { EditPartnersComponent } from './layout/components/miracle-components/partners-list/edit-partners/edit-partners.component';
import { EditFaqsComponent } from './layout/components/miracle-components/frequently-asked/edit-faqs/edit-faqs.component';
import { AddFaqsComponent } from './layout/components/miracle-components/frequently-asked/add-faqs/add-faqs.component';
import { ContractDetailsComponent } from './layout/components/miracle-components/investors/contract-details/contract-details.component';
import { EditContractsComponent } from './layout/components/miracle-components/contracts/edit-contracts/edit-contracts.component';
import { AddContractsComponent } from './layout/components/miracle-components/contracts/add-contracts/add-contracts.component';
import { EditContractsTypeComponent } from './layout/components/miracle-components/contracts-type/edit-contracts-type/edit-contracts-type.component';
import { AddContractsTypeComponent } from './layout/components/miracle-components/contracts-type/add-contracts-type/add-contracts-type.component';
import { ContractsTypeComponent } from './layout/components/miracle-components/contracts-type/contracts-type.component';
import { AddNewAboutComponent } from './layout/components/miracle-components/new-about/add-new-about/add-new-about.component';
import { EditNewAboutComponent } from './layout/components/miracle-components/new-about/edit-new-about/edit-new-about.component';
import { NewAboutComponent } from './layout/components/miracle-components/new-about/new-about.component';
import { NewContactUsComponent } from './layout/components/miracle-components/new-contact-us/new-contact-us.component';
import { NewContactUsDetailsComponent } from './layout/components/miracle-components/new-contact-us/new-contact-us-details/new-contact-us-details.component';
import { AddAlertsComponent } from './layout/components/miracle-components/alerts/add-alerts/add-alerts.component';
import { MCountriesComponent } from './layout/components/miracle-components/m-countries/m-countries.component';
import { AddMCountriesComponent } from './layout/components/miracle-components/m-countries/add-m-countries/add-m-countries.component';
import { MCitiesComponent } from './layout/components/miracle-components/m-cities/m-cities.component';
import { AddMCitiesComponent } from './layout/components/miracle-components/m-cities/add-m-cities/add-m-cities.component';
import { EditMCitiesComponent } from './layout/components/miracle-components/m-cities/edit-m-cities/edit-m-cities.component';
import { EditMCountriesComponent } from './layout/components/miracle-components/m-countries/edit-m-countries/edit-m-countries.component';
import { NoAuthPrivacyComponent } from './layout/components/miracle-components/privacy-policy/no-auth-privacy/no-auth-privacy.component';
import { AlertsDetailsComponent } from './layout/components/miracle-components/alerts/alerts-details/alerts-details.component';
import { DeleteAccountComponent } from './layout/components/miracle-components/delete-account/delete-account.component';
import { ChatComponent } from './layout/components/miracle-components/chat/chat.component';
import { ChatDetailsComponent } from './layout/components/miracle-components/chat/chat-details/chat-details.component';
import { PaymentsComponent } from './layout/components/miracle-components/payments/payments.component';
import { AddPaymentsComponent } from './layout/components/miracle-components/payments/add-payments/add-payments.component';
import { EditPaymentsComponent } from './layout/components/miracle-components/payments/edit-payments/edit-payments.component';
import { AddPaymentsAmountComponent } from './layout/components/miracle-components/payments/add-payments-amount/add-payments-amount.component';
import { NewsComponent } from './layout/components/miracle-components/news/news.component';
import { SectorsComponent } from './layout/components/miracle-components/sectors/sectors.component';
import { AddSectorsComponent } from './layout/components/miracle-components/sectors/add-sectors/add-sectors.component';
import { EditSectorsComponent } from './layout/components/miracle-components/sectors/edit-sectors/edit-sectors.component';
import { EditNewsComponent } from './layout/components/miracle-components/news/edit-news/edit-news.component';
import { AddNewsComponent } from './layout/components/miracle-components/news/add-news/add-news.component';
import { EditTeamMembersComponent } from './layout/components/miracle-components/team-members/edit-team-members/edit-team-members.component';
import { AddTeamMembersComponent } from './layout/components/miracle-components/team-members/add-team-members/add-team-members.component';
import { TeamMembersComponent } from './layout/components/miracle-components/team-members/team-members.component';
import { OurMessageComponent } from './layout/components/miracle-components/our-message/our-message.component';
import { AddOurMessageComponent } from './layout/components/miracle-components/our-message/add-our-message/add-our-message.component';
import { EditOurMessageComponent } from './layout/components/miracle-components/our-message/edit-our-message/edit-our-message.component';
import { ReportsComponent } from './layout/components/miracle-components/reports/reports.component';
import { NewPaginationComponent } from './layout/components/miracle-components/new-pagination/new-pagination.component';
import { EditReportsComponent } from './layout/components/miracle-components/reports/edit-reports/edit-reports.component';
import { AddReportsComponent } from './layout/components/miracle-components/reports/add-reports/add-reports.component';
import { VisionKsaComponent } from './layout/components/miracle-components/vision-ksa/vision-ksa.component';
import { AddVisionKsaComponent } from './layout/components/miracle-components/vision-ksa/add-vision-ksa/add-vision-ksa.component';
import { EditVisionKsaComponent } from './layout/components/miracle-components/vision-ksa/edit-vision-ksa/edit-vision-ksa.component';

// import { AddMCitiesComponent } from './layout/components/miracle-components/cities/add-m-cities/add-m-cities.component';
// import { AddMCountriesComponent } from './layout/components/miracle-components/countries/add-m-countries/add-m-countries.component';
// import { EditFaqsComponent } from './layout/components/miracle-components/frequently-asked/edit-faqs/edit-faqs.component';
// import { AddFaqsComponent } from './layout/components/miracle-components/frequently-asked/add-faqs/add-faqs.component';
// import { EditPartnersComponent } from './layout/components/miracle-components/partners-list/edit-partners/edit-partners.component';

const appRoutes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
  },
    // {path: '',   component: AnalyticsComponent },
    { path: '', redirectTo: '/analytics', pathMatch: 'full'},
    {path: 'employees',   component: EmployeesComponent },
    {path: 'job-title',   component: JobTitlesComponent },
    {path: 'add-job-title',   component: AddJobTitlesComponent },
    {path: 'job-title/:id',   component: EditJobTitlesComponent },
      {path: 'add-new-m-countries',   component: AddMCountriesComponent },
      {path: 'edit-m-countries/:id',   component: EditMCountriesComponent },
    {path: 'm-countries',   component: MCountriesComponent },
     {path: 'add-new-m-cities',   component: AddMCitiesComponent },
     {path: 'edit-m-cities/:id',   component: EditMCitiesComponent },
    {path: 'm-cities',   component: MCitiesComponent },
    {path: 'add-employees',   component: AddEmployeeComponent },
    {path: 'edit-employees/:id',   component: EditEmployeeComponent },
     {path: 'job-title/:id',   component: EditJobTitlesComponent },
    {path: 'employees-details/:id',   component: EmployeeDetailsComponent },
    {path: 'analytics',   component: AnalyticsComponent },
    {path: 'investors',   component: InvestorsComponent },
    {path: 'add-investors',   component: AddInvestorComponent },
    {path: 'edit-investors/:id',   component: EditInvestorComponent },
    {path: 'contract-details/:id',   component: ContractDetailsComponent },

    {path: 'investors-details/:id',   component: InvestorDetailsComponent },
    {path: 'alerts-details/:id',   component: AlertsDetailsComponent },
    {path: 'contracts',   component: ContractsComponent },
    {path: 'news',   component: NewsComponent },
    {path: 'add-news',   component: AddNewsComponent },
    {path: 'edit-news/:id',   component: EditNewsComponent },
    {path: 'team-members',   component: TeamMembersComponent },
    {path: 'add-team-members',   component: AddTeamMembersComponent },
    {path: 'edit-team-members/:id',   component: EditTeamMembersComponent },
    {path: 'our-message',   component: OurMessageComponent },
    {path: 'add-our-message',   component: AddOurMessageComponent },
    {path: 'edit-our-message/:id',   component: EditOurMessageComponent },

    {path: 'reports',   component: ReportsComponent },
    {path: 'add-reports',   component: AddReportsComponent },
    {path: 'edit-reports/:id',   component: EditReportsComponent },

    {path: 'add-sectors',   component: AddSectorsComponent },
    {path: 'edit-sectors/:id',   component: EditSectorsComponent },
    {path: 'sectors',   component: SectorsComponent },

    {path: 'add-vision-ksa',   component: AddVisionKsaComponent },
    {path: 'edit-vision-ksa/:id',   component: EditVisionKsaComponent },
    {path: 'vision-ksa',   component: VisionKsaComponent },



    {path: 'edit-contracts/:id',   component: EditContractsComponent },
    {path: 'add-contracts',   component: AddContractsComponent },
    {path: 'contracts-type',   component: ContractsTypeComponent },
    {path: 'edit-contracts-type/:id',   component: EditContractsTypeComponent },
    {path: 'add-contracts-type',   component: AddContractsTypeComponent },
    {path: 'alerts',   component: AlertsComponent },
        {path: 'auth-privacy',   component: NoAuthPrivacyComponent },
    {path: 'miracle-terms',   component: MiracleTermsComponent },
    {path: 'frequently',   component: FrequentlyAskedComponent },
    {path: 'add-faqs',   component: AddFaqsComponent },
    {path: 'edit-faqs/:id',   component: EditFaqsComponent },
    {path: 'aboutt',   component: AboutMiracleComponent },
    {path: 'new-contact-us',   component: NewContactUsComponent },
    {path: 'new-contact-us-details/:id',   component: NewContactUsDetailsComponent },
    {path: 'new-about',   component: NewAboutComponent },
    {path: 'add-new-about',   component: AddNewAboutComponent },
    {path: 'edit-new-about/:id',   component: EditNewAboutComponent },
    {path: 'partners',   component: PartnersListComponent },
     {path: 'partners-add',   component: PartnersAddComponent },
      {path: 'edit-partners/:id',   component: EditPartnersComponent },
    {path: 'privacy',   component: PrivacyPolicyComponent },
    {path: 'delete-account',   component: DeleteAccountComponent },
    {path: 'add-alerts',   component: AddAlertsComponent },
    {path: 'chats',   component: ChatComponent },
    {path: 'chats-detailes/:id',   component: ChatDetailsComponent },
    {path: 'payments',   component: PaymentsComponent },
    {path: 'add-payments/:id',   component: AddPaymentsComponent },
    {path: 'add-payments-amount/:id',   component: AddPaymentsAmountComponent },

    

    

    

    
    
// {
  //   path: '',
  //   redirectTo: '/pages/authentication/login-v2',
  //   pathMatch: 'full'
  // },
  {
    path: 'login',
    redirectTo: '/pages/authentication/login-v2',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/pages/miscellaneous/error' //Error 404 - Page not found
  },
  
];

@NgModule({
  declarations: [AppComponent , AdsComponent,AddAdsComponent , CounselorsComponent , 
    AddCounselorsComponent ,StoresOffersComponent, AddStoresOffersComponent,CancelationReasonComponent,
  AddCancelationReasonComponent,CompaniesComponent,AddCompaniesComponent,ConsultingComponent,
AddConsultingComponent,CategoriesComponent,AddCategpriesComponent,ServicesComponent,AddServicesComponent,
TagsComponent,AddTagsComponent,ArticlesComponent,AddArticlesComponent,OffersComponent,AddOffersComponent,
AddLanguagePlantcardsComponent,AddUsersComponent,UsersComponent,PlantCardsComponent,
SettingsDetailsComponent,TermsConditionsComponent,NotificationsComponent,AboutComponent,
CurrenciesComponent,CountriesComponent,CitiesComponent,LanguagePlansComponent,OpenScreensComponent,
LanguageLightComponent,GanatakCommunityComponent,LanguageRootComponent,LanguageSeedComponent,
LanguageSoilComponent,LanguageStemComponent,PaperformComponent,SizesComponent,LanguageCounselorspaymentComponent,
SlidersComponent , AddCurrenciesComponent , AddCountriesComponent,AddCitiesComponent, AddLanguagePlansComponent , AddOpenScreensComponent, AddLanguageLightComponent, AddGanatakCommunityComponent, AddLanguageRootComponent , AddLanguageSeedComponent,AddLanguageSoilComponent,AddLanguageStemComponent, AddPaperformComponent, AddSizesComponent ,AddCounselorsComponent,AddLanguageCounselorspaymentComponent,AddSizesComponent,AddCounselorsComponent, AddSlidersComponent , VouchersComponent , AddCounselorsComponent, SignInComponent,
EmployeesComponent,   AnalyticsComponent,   InvestorsComponent,
    AddInvestorComponent,  EditContractsComponent, AddContractsComponent, AddFaqsComponent,
     EditFaqsComponent,EmployeeDetailsComponent, InvestorDetailsComponent,AddPaymentsAmountComponent,
  EditInvestorComponent, ContractsComponent,   NewAboutComponent,AlertsDetailsComponent,
                       EditNewAboutComponent, NewContactUsDetailsComponent,
                       AddNewAboutComponent,JobTitlesComponent,MCitiesComponent,
    EditEmployeeComponent,  AddEmployeeComponent,    NewContactUsComponent,DeleteAccountComponent,
             AlertsComponent,  ContractsTypeComponent, AddContractsTypeComponent,
               EditContractsTypeComponent,  TermsConditionsComponent, FrequentlyAskedComponent,
             AboutMiracleComponent,NoAuthPrivacyComponent,CitiesComponent, 
             PrivacyPolicyComponent,    MiracleTermsComponent, PartnersListComponent, PartnersAddComponent, EmployeeAddComponent, JobTitlesComponent, AddJobTitlesComponent, EditJobTitlesComponent, EditPartnersComponent, ContractDetailsComponent, AddAlertsComponent, MCountriesComponent, AddMCountriesComponent, MCitiesComponent, AddMCitiesComponent, EditMCitiesComponent, EditMCountriesComponent
            , AboutMiracleComponent,PaymentsComponent,
             PrivacyPolicyComponent,    MiracleTermsComponent, PartnersListComponent, PartnersAddComponent, EmployeeAddComponent, JobTitlesComponent, AddJobTitlesComponent, EditJobTitlesComponent, EditPartnersComponent, ContractDetailsComponent, AddAlertsComponent, MCountriesComponent, AddMCountriesComponent, MCitiesComponent, AddMCitiesComponent, EditMCitiesComponent, EditMCountriesComponent, ChatComponent, ChatDetailsComponent, PaymentsComponent, AddPaymentsComponent, EditPaymentsComponent
 ,NewsComponent, SectorsComponent,NewPaginationComponent,
    TeamMembersComponent, OurMessageComponent,
                          AddOurMessageComponent, VisionKsaComponent,
                                                                          AddVisionKsaComponent,
                                                                          EditVisionKsaComponent,
                          EditOurMessageComponent,ReportsComponent,
                      AddTeamMembersComponent,
                      EditTeamMembersComponent,AddReportsComponent,
                                      EditReportsComponent
,AddNewsComponent, EditNewsComponent, EditSectorsComponent, AddSectorsComponent
],
  imports: [
    BrowserModule,
    BrowserAnimationsModule, 
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled', // Add options right here
      relativeLinkResolution: 'legacy'
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
 ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      preventDuplicates: true,
    }),
    // App modules
    LayoutModule,
    SampleModule,
    NgxDatatableModule,
     FormsModule,ReactiveFormsModule, FormsModule , CommonModule
  ],

  bootstrap: [AppComponent],
  providers: [{provide:HTTP_INTERCEPTORS , useClass:JwtInterceptor, multi:true}]
})
export class AppModule {}
   